<ng-container *transloco="let t">
  <table class="icu-from-to-date-container">
    <tbody>
      <tr>
        <td style="width: fit-content;" class="from-title">
          <span class="icu-date-from-to-title">{{t('From')}}&nbsp;: </span>
        </td>
        <td class="icu-input-box-table-cell from-date">
          <div class="icu-search-div">
            <mat-form-field appearance='outline' class="icu-search-box">
              <input [(ngModel)]="fromDate" (ngModelChange)="fromDateChange.emit(fromDate)" matInput [ngxMatDatetimePicker]="pickerFrom" />
              <mat-datepicker-toggle class="icu-calendar-job" matSuffix [for]="$any(pickerFrom)">
              </mat-datepicker-toggle>
              <ngx-mat-datetime-picker #pickerFrom>
              </ngx-mat-datetime-picker>
            </mat-form-field>
          </div>
        </td>
      </tr>
      <div class="icu-gap"></div>
      <div class="icu-dash-separartor" style="display: none;
      justify-content: center;
      align-items: center;
      padding-left: 10px;">
      <span>--</span>
      </div>
      <tr>
        <td style="width: fit-content;" class="to-title">
          <span class="icu-date-from-to-title">{{t('To')}} :</span>
        </td>
        <td class="icu-input-box-table-cell to-date">
          <div class="icu-search-div">
            <mat-form-field appearance='outline' class="icu-search-box">
              <input [(ngModel)]="toDate" (ngModelChange)="toDateChange.emit(toDate)" matInput [ngxMatDatetimePicker]="pickerTo" />
              <mat-datepicker-toggle class="icu-calendar-job" matSuffix [for]="$any(pickerTo)">
              </mat-datepicker-toggle>
              <ngx-mat-datetime-picker #pickerTo>
              </ngx-mat-datetime-picker>
            </mat-form-field>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>
